@import (reference) '../../../../../constants/spacing.module.less';

.container {
  align-items: center;
  justify-content: center;
  gap: @space-16;
  padding: @space-32 @space-0 @space-16;
}

.image {
  display: block;
}

.message {
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: var(--default--text-color--16);
  text-align: center;
}
